import { render, staticRenderFns } from "./ipstatistics.vue?vue&type=template&id=6dd5bf04&scoped=true"
import script from "./ipstatistics.vue?vue&type=script&lang=js"
export * from "./ipstatistics.vue?vue&type=script&lang=js"
import style0 from "./ipstatistics.vue?vue&type=style&index=0&id=6dd5bf04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd5bf04",
  null
  
)

export default component.exports